export const getRandomString = (length, chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789") => {
	let result = "";

	while (length--)
		result += chars.charAt(Math.floor(Math.random() * chars.length));

	return result;
};

export const hasBrowserWebRtcSupport = () => {
	if (navigator.userAgent.indexOf("Edge") !== -1 ||
		(navigator.userAgent.indexOf("Chrome") === -1 && navigator.userAgent.indexOf("Safari") !== -1)
	)
		return false;

	return typeof navigator.mediaDevices !== "undefined";
};

// https://stackoverflow.com/a/13382873
export const getScrollbarWidth = () => {
	// Creating invisible container
	const outer = document.createElement("div");
	outer.style.visibility = "hidden";
	outer.style.overflow = "scroll"; // forcing scrollbar to appear
	outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
	document.body.appendChild(outer);

	// Creating inner element and placing it in the container
	const inner = document.createElement("div");
	outer.appendChild(inner);

	// Calculating difference between container's full width and the child width
	const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

	// Removing temporary elements from the DOM
	document.body.removeChild(outer);

	return scrollbarWidth;
};
